import React, { useEffect, useCallback } from "react";
import { useState } from "react";
import { TbEye, TbEyeOff } from "react-icons/tb";
import { MdKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { useAccount } from "../../hooks/useAccount";
import { getBankCode } from "../../utils";
import { css } from "@emotion/react";
import BeatLoader from "react-spinners/BeatLoader";
import api from "../../services/api";
import { useAuth } from "../../hooks/useAuth";
import { useTed } from "../../hooks/useTed";

import "./Style.css";

const PaginaInicial = () => {
  const { isLogged, getProfile, user } = useAuth();
  const { balance, getBalance } = useAccount();
  const { setAlreadyFavorites } = useTed()

  const [mostraSaldo, SetMostraSaldo] = useState(false);
  const [transferenciasRecentes, setTransferenciasRecentes] = useState([]);

  const override = css`
    display: flex;
    margin: 0 auto;
    border-color: red;
  `;

  const getTransferenciasRecentes = useCallback(async () => {
    const response = await api.get("/transfer/recents", {
      accountId: localStorage.getItem("accountId"),
    });
    setTransferenciasRecentes(response.data.elements);
    console.log(response.data.elements)
  }, []);

  const getNamedFirstChar = useCallback((name) => {
    const [firstName = "", lastName = ""] = name.split(" ");
    return (
      firstName?.charAt(0)?.toUpperCase() +
        lastName?.charAt(0)?.toUpperCase() || ""
    );
  }, []);

  useEffect(() => {
    if (isLogged) {
      getProfile();
    }
  }, [isLogged]);

  useEffect(() => {
    getTransferenciasRecentes();
  }, []);

  useEffect(() => {
    if (user.account) {
      getBalance();
    }
  }, [user]);

  return (
    <div className="pagina-principal">
      <div className="header">
        <div className="col-md-5">
          <h1>Conta Corrente</h1>
        </div>
        <div className="col-md-5">
          <span>Conta Corrente</span>
          <div className="d-flex">
            <div className="col-md-4">
              <p>
                R$:
                <label>
                  {mostraSaldo
                    ? balance || (
                        <BeatLoader
                          color="var(--text-primary)"
                          loading={true}
                          css={override}
                          size={14}
                        />
                      )
                    : "-"}
                </label>
              </p>
            </div>
            <div className="col-md-2">
              {mostraSaldo ? (
                <TbEyeOff
                  size={24}
                  onClick={() => {
                    SetMostraSaldo(!mostraSaldo);
                  }}
                ></TbEyeOff>
              ) : (
                <TbEye
                  size={24}
                  onClick={() => {
                    SetMostraSaldo(!mostraSaldo);
                  }}
                ></TbEye>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="body">
        <div className="d-flex col-md-10">
          <div className="col-md-6">
            <h1>
              Transferências <MdKeyboardArrowRight />
            </h1>
          </div>
          <div className="d-flex col-md-6">
            <Link to={"/pagina-pix"}>
              <div className="svg-circle">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="40"
                  height="40"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    d="M8.62736 9.99716C8.775 9.84952 9.02926 9.84952 9.17691 9.99716L11.2821 12.1024C11.6704 12.4906 12.1871 12.7039 12.7339 12.7039H13.1468L10.492 15.3587C9.66357 16.1652 8.31841 16.1652 7.48998 15.3587L4.82426 12.6957H5.07853C5.62534 12.6957 6.14208 12.4824 6.53032 12.0942L8.62736 9.99716ZM9.17691 7.98488C9.00192 8.13525 8.77773 8.13799 8.62736 7.98488L6.53032 5.88784C6.14208 5.475 5.62534 5.28635 5.07853 5.28635H4.82426L7.48725 2.62226C8.31841 1.79258 9.66357 1.79258 10.492 2.62226L13.1495 5.27814H12.7339C12.1871 5.27814 11.6704 5.4914 11.2821 5.87964L9.17691 7.98488ZM5.07853 5.90151C5.45583 5.90151 5.80306 6.05462 6.09287 6.32256L8.1899 8.4196C8.38676 8.59184 8.64376 8.71488 8.9035 8.71488C9.1605 8.71488 9.4175 8.59184 9.61436 8.4196L11.7196 6.31436C11.9875 6.04915 12.3566 5.89604 12.7339 5.89604H13.7647L15.3587 7.49001C16.1871 8.31844 16.1871 9.6636 15.3587 10.492L13.7647 12.086H12.7339C12.3566 12.086 11.9875 11.9329 11.7196 11.6649L9.61436 9.55971C9.23432 9.17967 8.56994 9.17967 8.1899 9.56244L6.09287 11.6567C5.80306 11.9247 5.45583 12.0778 5.07853 12.0778H4.20854L2.62223 10.492C1.79255 9.6636 1.79255 8.31844 2.62223 7.49001L4.20854 5.90151H5.07853Z"
                    fill="var(--text-primary)"
                  />
                </svg>
              </div>
              <p>PIX</p>
            </Link>
            <Link to={"/pagina-ted"}>
              <div className="svg-circle">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="40"
                  height="40"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.63181 2.44714C7.93715 2.72703 7.95777 3.20146 7.67788 3.5068L4.70494 6.75H15C15.4142 6.75 15.75 7.08579 15.75 7.5C15.75 7.91422 15.4142 8.25 15 8.25H3.00002C2.70259 8.25 2.43327 8.07425 2.3135 7.802C2.19374 7.52975 2.24617 7.21246 2.44715 6.99321L6.57215 2.49321C6.85204 2.18787 7.32647 2.16724 7.63181 2.44714ZM2.25002 10.5C2.25002 10.0858 2.5858 9.75 3.00002 9.75H15C15.2974 9.75 15.5668 9.92576 15.6865 10.198C15.8063 10.4703 15.7539 10.7875 15.5529 11.0068L11.4279 15.5068C11.148 15.8121 10.6736 15.8328 10.3682 15.5529C10.0629 15.273 10.0423 14.7986 10.3221 14.4932L13.2951 11.25H3.00002C2.5858 11.25 2.25002 10.9142 2.25002 10.5Z"
                    fill="var(--text-primary)"
                  />
                </svg>
              </div>
              <p>TED</p>
            </Link>
            <button disabled title="Em Breve">
              <div className="svg-circle disabled">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="34"
                  height="24"
                  viewBox="0 0 34 24"
                  fill="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.33331 3.66671C4.89128 3.66671 4.46736 3.8423 4.1548 4.15486C3.84224 4.46742 3.66665 4.89135 3.66665 5.33337V18.6667C3.66665 19.1087 3.84224 19.5327 4.1548 19.8452C4.46736 20.1578 4.89129 20.3334 5.33331 20.3334H28.6666C29.1087 20.3334 29.5326 20.1578 29.8452 19.8452C30.1577 19.5327 30.3333 19.1087 30.3333 18.6667V5.33337C30.3333 4.89135 30.1577 4.46742 29.8452 4.15486C29.5326 3.8423 29.1087 3.66671 28.6666 3.66671H5.33331ZM1.79778 1.79784C2.73546 0.860158 4.00723 0.333374 5.33331 0.333374H28.6666C29.9927 0.333374 31.2645 0.860158 32.2022 1.79784C33.1399 2.73552 33.6666 4.00729 33.6666 5.33337V18.6667C33.6666 19.9928 33.1399 21.2646 32.2022 22.2022C31.2645 23.1399 29.9927 23.6667 28.6666 23.6667H5.33331C4.00723 23.6667 2.73546 23.1399 1.79778 22.2022C0.860097 21.2646 0.333313 19.9928 0.333313 18.6667V5.33337C0.333313 4.00729 0.860097 2.73552 1.79778 1.79784ZM12.2859 7.286C13.5362 6.03575 15.2319 5.33337 17 5.33337C18.7681 5.33337 20.4638 6.03575 21.714 7.286C22.9643 8.53624 23.6666 10.2319 23.6666 12C23.6666 13.7682 22.9643 15.4638 21.714 16.7141C20.4638 17.9643 18.7681 18.6667 17 18.6667C15.2319 18.6667 13.5362 17.9643 12.2859 16.7141C11.0357 15.4638 10.3333 13.7682 10.3333 12C10.3333 10.2319 11.0357 8.53624 12.2859 7.286ZM17 8.66671C16.1159 8.66671 15.2681 9.0179 14.643 9.64302C14.0178 10.2681 13.6666 11.116 13.6666 12C13.6666 12.8841 14.0178 13.7319 14.643 14.3571C15.2681 14.9822 16.1159 15.3334 17 15.3334C17.884 15.3334 18.7319 14.9822 19.357 14.3571C19.9821 13.7319 20.3333 12.8841 20.3333 12C20.3333 11.116 19.9821 10.2681 19.357 9.64302C18.7319 9.0179 17.884 8.66671 17 8.66671ZM5.33331 12C5.33331 11.0796 6.0795 10.3334 6.99998 10.3334H7.01665C7.93712 10.3334 8.68331 11.0796 8.68331 12C8.68331 12.9205 7.93712 13.6667 7.01665 13.6667H6.99998C6.0795 13.6667 5.33331 12.9205 5.33331 12ZM25.3333 12C25.3333 11.0796 26.0795 10.3334 27 10.3334H27.0166C27.9371 10.3334 28.6833 11.0796 28.6833 12C28.6833 12.9205 27.9371 13.6667 27.0166 13.6667H27C26.0795 13.6667 25.3333 12.9205 25.3333 12Z"
                    fill="var(--text-primary)"
                  />
                </svg>
              </div>
              <p>E-CHECK</p>
            </button>
          </div>
        </div>
        {!!transferenciasRecentes.length && (
          <div className="col-md-10">
            <h2>Tranferências Recentes</h2>
            <div className="d-flex">
              {transferenciasRecentes.map((item) => {
                return (
                  <div className="recent-card" key={item.id}>
                    {item.pix ? (
                      <Link
                        state={{
                          pixKey: item?.toPixKey,
                        }}
                        to={{ pathname: "/pagina-pagar-pix" }}
                        key={item.id}
                      >
                        <div className="recent-icons">
                          {getNamedFirstChar(item.toName)}
                        </div>
                        <div className="recent-content">
                          <p>
                            {item.toName.split(" ").length > 1
                              ? item.toName.split(" ")[0] +
                                " " +
                                item.toName.split(" ")[1]
                              : item.toName.split(" ")[0].split("")[0]}
                          </p>
                          <span>{getBankCode(item.toBank) || ""}</span>
                        </div>
                      </Link>
                    ) : (
                      <Link
                        onClick={() => setAlreadyFavorites(false)}
                        state={{
                          idTransfer: item?.id || undefined,
                        }}
                        to={{ pathname: "/pagina-transferencia" }}
                        key={item.id}
                      >
                        <div className="recent-icons">
                          {getNamedFirstChar(item.toName)}
                        </div>
                        <div className="recent-content">
                          <p>{item.toName}</p>
                          <span>{getBankCode(item.toBank) || ""}</span>
                        </div>
                      </Link>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
      <div className="footer">
        <div className="col-md-10">
          <h1>Descubra mais</h1>
        </div>
        <div className="d-flex col-md-10">
          <Link to={"/contato"}>
            <div className="card-footer ">
              <img src="images/contato.png" />
              <h3>Contato</h3>
              <p>Precisando resolver alguma coisa, fale conosco</p>
            </div>
          </Link>

          {/* <Link to={'/perguntas-frequentes'}>
            <div className='card-footer'>
              <img src='images/perguntas-frequentes.png'/>
              <h3>Perguntas Frequentes</h3>
              <p>Queremos responder as suas dúvidas com asssertividade</p>
            </div>
          </Link> */}

          <a href={process.env.REACT_APP_COMPANY_SITE} target="_blank">
            <div className="card-footer">
              <img src="images/pagina-corporativa.png" />
              <h3>Página Corporativa</h3>
              <p>Quem somos, nossa visão e propósito</p>
            </div>
          </a>
        </div>
      </div>
      <ToastContainer limit={2} />
    </div>
  );
};

export default PaginaInicial;
